import React, { useMemo, useState } from 'react';
import creditCardType from 'credit-card-type';
import { ReactComponent as VisaIcon } from '../assets/icons/svg/logo_visa.svg';
import { ReactComponent as MasterIcon } from '../assets/icons/svg/logo_master_card.svg';
import { ReactComponent as AmexIcon } from '../assets/icons/svg/logo_amex.svg';

const brandIcon = (type) => {
  switch (type) {
    case 'visa':
      return <VisaIcon style={{ height: 18 }} />;
    case 'mastercard':
      return <MasterIcon style={{ height: 18 }} />;
    case 'american-express':
      return <AmexIcon style={{ height: 18 }} />;
    default:
      return <span style={{ fontSize: 12, color: '#7B8492' }}>{type}</span>;
  }
};

const onlyDigits = (s) => String(s || '').replace(/\D/g, '');

const luhnCheck = (num) => {
  const s = onlyDigits(num);
  if (!s) return false;
  let sum = 0;
  let dbl = false;
  for (let i = s.length - 1; i >= 0; i--) {
    let d = s.charCodeAt(i) - 48;
    if (dbl) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    dbl = !dbl;
  }
  return sum % 10 === 0;
};

const formatWithGaps = (value, gaps = []) => {
  const digits = onlyDigits(value);
  if (!gaps?.length) return digits;
  const parts = [];
  let last = 0;
  for (const g of gaps) {
    parts.push(digits.slice(last, g));
    last = g;
  }
  parts.push(digits.slice(last));
  return parts.filter(Boolean).join(' ');
};

export default function TestPage() {
  const [input, setInput] = useState('');

  const results = useMemo(() => creditCardType(onlyDigits(input)), [input]);
  const primary = results[0] || null;
  const formatted = useMemo(
    () => (primary ? formatWithGaps(input, primary.gaps) : onlyDigits(input)),
    [input, primary]
  );
  const isLuhnValid = useMemo(() => (onlyDigits(input).length >= 12 ? luhnCheck(input) : null), [input]);

  return (
    <div style={{ maxWidth: 640, margin: '24px auto', padding: 16 }}>
      <h2 style={{ marginBottom: 16 }}>카드 정보 출력기</h2>

      <label htmlFor="card-number" style={{ display: 'block', marginBottom: 8 }}>카드 번호</label>
      <input
        id="card-number"
        type="text"
        inputMode="numeric"
        placeholder="숫자만 입력 (예: 4111111111111111)"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{ width: '100%', height: 42, padding: '8px 12px', border: '1px solid #DBDEE1', borderRadius: 6 }}
      />

      <div style={{ marginTop: 12, color: '#7B8492', fontSize: 13 }}>표시: {formatted || '-'}</div>

      <div style={{ marginTop: 20 }}>
        <h4 style={{ margin: 0, marginBottom: 8, fontWeight: 500 }}>결과</h4>
        {results.length === 0 ? (
          <div style={{ color: '#7B8492' }}>브랜드 후보 없음</div>
        ) : (
          <div style={{ display: 'grid', gap: 8 }}>
            {results.map((r) => (
              <div key={r.type} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', border: '1px solid #EBEBEB', borderRadius: 6 }}>
                <div style={{ width: 64 }}>{brandIcon(r.type)}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600 }}>{r.niceType}</div>
                  <div style={{ color: '#7B8492', fontSize: 13 }}>type: {r.type}</div>
                </div>
                <div style={{ textAlign: 'right', fontSize: 13, color: '#4E5867' }}>
                  <div>길이: {r.lengths?.join(', ') || '-'}</div>
                  <div>{(r.code?.name || '보안코드').toUpperCase()}: {r.code?.size ? `${r.code.size}자리` : '-'}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginTop: 20 }}>
        <h4 style={{ margin: 0, marginBottom: 8, fontWeight: 500 }}>유효성 (Luhn)</h4>
        <div style={{ fontWeight: 600, color: isLuhnValid == null ? '#7B8492' : isLuhnValid ? '#0A7F2E' : '#C12A2A' }}>
          {isLuhnValid == null ? '검사 대기 (자리수 부족)' : isLuhnValid ? '유효함' : '유효하지 않음'}
        </div>
      </div>
    </div>
  );
}
